import {orderBy} from "lodash";
export const ApplyVersionController = ($scope,
                                           $mdDialog,
                                           callback,
                                           versions
) => {
    "ngInject";

    $scope.callback = callback;
    $scope.versions = orderBy(versions, (v) => {
        return v.version.replace(/[^\d.]/g, "").split(".").map( n => +n+100000 ).join(".");
    }, ["desc"]);
    $scope.versions = $scope.versions.splice(0, 4);

    $scope.selectedVersion = {
        version: null
    };

    $scope.closeDialog = () => {
        $mdDialog.hide();
    };

    $scope.create = () => {
        callback($scope.selectedVersion.version);
        document.onkeypress = () => {};
        $mdDialog.hide();
    };

    document.onkeypress = (ev) => {
        if (ev.key === "Enter") {
            if ($scope.selectedVersion.version) {
                $scope.create();
            }
        }
    };
};


// WEBPACK FOOTER //
// ./sources/components/booths/apply-version/apply-version.js